<!--
@Description: 模糊图片组件
@Author: 吳廣帥
@Date:2021/11/30 - 16:50
@Name:BlurImage
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.BlurImage-box{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &__img{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  &__info{
    position: relative;
    z-index: 100;
    //width: 4.5rem;
    //height: 2.1rem;
    padding: 0.6rem 0.6rem 0.4rem 0.6rem;
    background: #ffffff;
    box-shadow: 0 0.05rem 0.1rem 0.01rem rgba(44, 49, 103, 0.12);
    border-radius: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &__title{
      font-weight: 500;
      font-family: "PingFang SC";
    }
    &__button{
      display: block;
      margin-top: 0.3rem;
      padding: 0.2rem 0.4rem;
      background: #2A89F4;
      border-radius: 0.1rem;
      color: #ffffff;
    }
  }
}
</style>
<template>
  <!--  组件最外层盒子-->
  <div class="BlurImage-box">
    <div class="BlurImage-box__info">
      <div class="BlurImage-box__info__title">
        {{ vipText }}
      </div>
      <router-link :to="to"  class="BlurImage-box__info__button">
        {{linkText}}
      </router-link>
    </div>
    <img :src="src" alt="" class="BlurImage-box__img">
  </div>
</template>
<script>

export default {
  /** 数据区 **/
  props: {
    src:{ type:String, default:'' },
    vipText: { type:String, default:' 升级为专业版会员，即可查看' },
    to:{ type:String, default:'/dredgeVip' },
    linkText:{ type:String, default:'立即升级' }
  },
}
</script>








